<template>
  <div class="rating-container">
    <content-loader height="150">
      <circle cx="28" cy="30" r="20"/>
      <rect x="55" y="15" rx="4" ry= "4" width="40%" height="10"/>
      <rect x="55" y="35" rx="4" ry= "4" width="75%" height="12"/>
      <rect x="8" y="70" rx="4" ry= "4" width="96%" height="35"/>
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader} from "vue-content-loader";

export default {
  name: "CodeCommentLoadingIndicator",
  components: { ContentLoader },
  props: {height: {type: Number, default: 600}},
}
</script>

<style scoped>

</style>